// src/components/Alarme/Bombas/Bombas.js
import React from "react";
import "../../../styles/desktop/bombas.css";
//import ControleBombasSpa from "./controleBombas/controleBombas";

export default function Bombas({ bombas = [] }) {

  console.log(bombas)

  if (!bombas.length) {
    return (
      <div className="campoAlarmes">
        {/* ControleBombasSpa />*/}
        
        
        {/* Mensagem quando não há alarmes de bombas */}
        <p className="msgVaziaBombas">Sem alarme de Bombas</p>
      </div>
    );
  }

  // Agrupa os alarmes por grupo
  const grupos = bombas.reduce((acc, bomba) => {
    const tipo = bomba.grupo || "Bombas";
    if (!acc[tipo]) acc[tipo] = [];
    acc[tipo].push(bomba);
    return acc;
  }, {});

  return (
    <div className="campoAlarmes">
      <div className="GrupoAlarmes">
        {/*  <ControleBombasSpa /> */}
       

        {/* Seção de Alarmes de Bombas */}
        {Object.entries(grupos).map(([grupoNome, alarmes]) => (
          <div key={grupoNome} className="grupoAlarme">
            <h3 className="grupoTitulo">{grupoNome}</h3>
            <div className="campo-grupo-alarmes">
              {alarmes.map((b) => (
                <div key={b.id} className="alarme">
                  <p className="titleAlarme">{b.desc}</p>
                  <div className={b.status ? "alertCircle" : "circleAlarm"}>
                    <p>{b.status ? "Defeito" : "Normal"}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}